<template>
	<div>
		<div class="bj_img_h">
			<div style="margin-top: 20px; margin-bottom: 20px;">
				<div>
					<div style="width: 100%;">
						<img style="width: 100%;border-radius:5px;"
							src="https://img.hsnms.com/20220414/1649945820.jpg" />
					</div>
				</div>
			</div>


			<div class="span12" style="margin-top: 5px;margin-bottom: 5px;" v-for="(item, index) in data_list_a.data"
				@click="route1(item.connect)">
				<!--t_10-->
				<div class="row">
					<div class="col-3" style="padding-right:1px;">
						<div style="position:relative;width:100%;">
							<img style="width: 100%; border-radius:3%;" :src=item.imgages_a />

						</div>
					</div>
					<div class="col-9">
						<h4>{{item.title}}</h4>
						<h6>{{item.describe}}</h6>
					</div>
				</div>
				<hr />
			</div>
			<el-button class="bin_tijiao_data" type="primary" v-if="data_list_a.v" @click="list_a">
				更多内容
			</el-button>




			<div style="height: 20px;"></div>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data_list_a: {
					data: [],
					page: 1,
					v: false,
				},
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				},
				tabPosition: 'top',
				usable: '1',
				tabs: [{
					name: '1',
					label: '学习宣传'
				}]
			}
		},
		mounted() {
			this.list_a()
		},
		methods: {
			route1: function(myurl) {
				window.open(myurl, "_blank");
			},
			list_a() {
				var datas = this.data_list_a;
				this.$api.getAPI("data/info/?type_id=202204004&page=" + datas.page, {
					key_id: this.$route.query.id,
				}).then(res => {
					var lists = res.data.data.data[0].models;
					if (lists.length == 10) {
						datas.v = true;
						this.data_list_a.page = datas.page + 1;
					} else {
						this.data_list_a.v = false;
					}
					for (let i = 0; i < lists.length; i++) {
						this.data_list_a.data.push(lists[i])
					}
				})
			},
			handleClick(tab) {
				console.log(tab)
			}
		}
	}
</script>

<style>
	.bin_tijiao_data {
		height: 50px;
		width: 100%;
		font-size: 16px;
		opacity: 0.6;
	}

	.bin_tijiao {
		height: 50px;
		width: 100%;
		font-size: 16px;
		opacity: 0.6;
	}

	.header {
		height: 20rem;
		color: #fff;
		background: url(http://www.baiduhrb.com/fjh/images/user_bg.png);
		background-size: 100% 100%;
	}

	.header .logo {
		display: block;
		float: left;
		margin-left: .8rem;
		margin-top: -4rem;
	}

	.header .logo img {
		position: relative;
		overflow-x: hidden;
		width: 45%;
		height: auto;
		top: 0px;
	}

	.m-slider {
		overflow-x: hidden;
		position: relative;
		margin-top: -10rem;
		border-radius: .45em;
	}

	.zhibo {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.loupan {
		opacity: 0.6;
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.jiage {
		background: #c5114f;
		text-align: center;
		color: #fff;
	}

	.h_hei {
		border-left: 5px solid #c5114f;
		padding-left: 5px;
	}

	.container-fluid {
		margin-top: 0px !important;
		max-width: 1200px;
	}

	.el-tabs__item {
		font-size: 16px !important;


	}

	.el-tabs__item is-top is-active {
		width: 50% !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/views/jjgh/xxxc.vue